import {SingleSimulation} from '../types/SingleSimulation'
import {FILTERS_TITLES, Global, QUERY_PARAMS, TODAY} from './variables'
import {addSimulation} from '../features/configurationsModelsData/configurationModelsDataSlice'
import store from '../app/store'
import isEmpty from 'lodash.isempty'
// import {capitalize} from 'lodash'
import {setLegalNotesText} from '../features/layersHandle/layersHandleSlice'
import {
    closeDisclaimerLayer,
    openDisclaimerLayer,
} from '../app/layers/launchers/LegalNotesLayerHandle'
import {closeExternalLinkPopUpLayer} from '../app/layers/launchers/ExternalLinkPupUpLayerHandle'
import {useEffect, useRef} from 'react'

export const numberFormat = (number: number) => {
    // eslint-disable-next-line security/detect-unsafe-regex
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}

export const addPercent = (value: string) => {
    if (value !== null) {
        return value.replace('.', ',') + Global.PERCENTAGE
    }

    return
}
export const currencyFormat = (price: string) => {
    const priceValue = numberFormat(Number(price))

    return priceValue + Global.EURO
}

export const getValidSimulationsWithModel = (
    simulations: SingleSimulation[],
    model: string
) => {
    const validSimulations: SingleSimulation[] = []

    simulations.map((simulation: SingleSimulation) => {
        const validToDate = new Date(simulation.valid_to)
            .toISOString()
            .substring(0, 10)

        if (TODAY <= validToDate) {
            const simulationWithModel: SingleSimulation = {
                ...simulation,
                model,
            }

            validSimulations.push(simulationWithModel)

            store.dispatch(addSimulation(simulationWithModel))
        }
    })

    return validSimulations
}

export const isBetweenRange = (x: string, min: number, max: number) => {
    const parsedNumber = parseFloat(x)

    return parsedNumber >= min && parsedNumber <= max
}

export const isInRange = (rangeArray: string | any[], value: string) => {
    if (!Array.isArray(rangeArray) || !rangeArray.length) {
        return true
    }

    return isBetweenRange(value, rangeArray[0], rangeArray[1])
}

export const showSimulationByAdvance = (simulation: SingleSimulation) => {
    const advanceRanges = store.getState().filterValues.advance
    if (isEmpty(advanceRanges)) {
        return true
    }

    for (const range of advanceRanges) {
        const [start, end] = range.split('-').map(Number)
        if (isBetweenRange(simulation.advance, start, end)) {
            return true
        }
    }

    return false
}

export const showSimulationByMonthlyRange = (simulation: SingleSimulation) =>
    isInRange(
        store.getState().filterValues.monthlyRange,
        simulation.monthly_payment
    )

export const openLegalNotes = (text: string) => {
    store.dispatch(setLegalNotesText(text))
    openDisclaimerLayer()
}

export const closeLayers = () => {
    closeDisclaimerLayer()
    closeExternalLinkPopUpLayer()
}

export const getLabel = (title: string): string => {
    switch (title) {
        case FILTERS_TITLES.monthlyRange:
            return QUERY_PARAMS.monthlyRange
        case FILTERS_TITLES.advance:
            return QUERY_PARAMS.advance
        case FILTERS_TITLES.totKm:
            return QUERY_PARAMS.totKm
        case FILTERS_TITLES.period:
            return QUERY_PARAMS.period
        case FILTERS_TITLES.model:
            return QUERY_PARAMS.model
        case FILTERS_TITLES.fuel:
            return QUERY_PARAMS.fuel
        default:
            return ''
    }
}
export const setUrlParams = (
    historyService: any,
    paramLabel: string,
    value: string
) => {
    if (!paramLabel) {
        return
    }

    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)

    // The hosting CMS appends a `-app` suffix to every query parameter it
    // forwards to the feature app. We must therefore write the params back
    // WITHOUT the `-app` suffix, otherwise the CMS keeps appending it on
    // every subsequent navigation producing keys like
    // `kmTotali-app-app-app=30000`. The regex strips ANY number of trailing
    // `-app` occurrences (not just one) to recover from URLs that may
    // already have accumulated suffixes.
    const stripAppSuffix = (key: string): string =>
        key.replace(/(?:-app)+$/, '')

    const normalizedParams = new URLSearchParams()
    urlParams.forEach((val, key) => {
        normalizedParams.set(stripAppSuffix(key), val)
    })

    const paramLabelClean = stripAppSuffix(paramLabel)

    if (isEmpty(value)) {
        normalizedParams.delete(paramLabelClean)
    } else {
        normalizedParams.set(paramLabelClean, value)
    }

    const newQueryString = normalizedParams.toString()
    historyService.history.push(`/?${newQueryString}`)
}

export const appendParamsToUrl = (
    baseUrl: string,
    newParams: string[]
): string => {
    if (!newParams.length) {
        return baseUrl
    }

    const separator = baseUrl.includes(Global.QUESTION_MARK)
        ? Global.AND
        : Global.QUESTION_MARK

    return baseUrl + separator + newParams.join(Global.AND)
}

export const usePrevious = <T>(value: T) => {
    const ref = useRef(value)
    useEffect(() => {
        ref.current = value
    }, [value])

    return ref.current
}
